<mat-spinner
  *ngIf="!init"
  style="margin: auto"
  color="primary"
  diameter="28"
></mat-spinner>

<div *ngIf="init" class="bottom-space">
  <div class="title" *ngIf="this.title">{{ title }}</div>

  <div class="subtitle" *ngIf="this.subtitle">{{ this.subtitle }}</div>

  <div *ngIf="!hideUpload">
    <button
      class="btn button ipad-overridable-button"
      type="button"
      (click)="disabled ? printDisabledWarningMessage() : fileInput.click()"
    >
      <span>{{ uploadButtonLabel }}</span>

      <input
        #fileInput
        type="file"
        style="display: none"
        ng2FileSelect
        [uploader]="uploader"
        [disabled]="disabled"
        (onFileSelected)="fileAdded($event)"
        accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpg,image/jpeg,application/pdf"
        multiple
      />
    </button>
  </div>

  <div
    *ngIf="!hideUploadedImages"
    class="d-flex images"
    [ngClass]="noLeftSpace ? 'no-left-space' : ''"
  >
    <ng-container *ngIf="inputProduct || inputProjectPlacement">
      <div
        *ngFor="let item of productAssets; index as i"
        class="align-middle max-picker-width"
        [ngClass]="getAssetClass(item, i == 0)"
        matTooltip="{{ item?.asset?.name }}"
      >
        <div
          *ngIf="
            item.archived === false ||
            client ||
            fromOldSystem ||
            (offlineUpload && !item.archived)
          "
          class="d-flex box click-link max-picker-width"
        >
          <a
            download="{{ item.asset.name }}"
            [href]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
            style="margin-right: 7px"
            class="d-flex box"
          >
            <div class="filename">{{ shortenName(item?.asset?.name) }}</div>

            <a>
              <mat-icon aria-hidden="false" aria-label="remove">
                cloud_download
              </mat-icon>
            </a>
          </a>

          <a *ngIf="!disabled">
            <mat-icon
              style="cursor: pointer"
              aria-hidden="false"
              aria-label="remove"
              (click)="removeFile(item, i)"
            >
              delete
            </mat-icon>
          </a>
        </div>

        <div
          *ngIf="
            item.archived === false ||
            client ||
            fromOldSystem ||
            (offlineUpload && !item.archived)
          "
        >
          <a
            class="click-link"
            [href]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
            *ngIf="isImage(item.asset)"
            data-lightbox="product"
          >
            <img
              class="max-picker-width max-picker-height"
              *ngIf="isImage(item.asset)"
              [src]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
            />
          </a>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="inputProductSize">
      <div
        *ngFor="let item of productSizeAssets; index as i"
        class="align-middle max-picker-width"
        [ngClass]="getSizeAssetClass(item, i == 0)"
        matTooltip="{{ item?.asset?.name }}"
      >
        <!-- A lot of duplicated html below, can attempt cleanup with ng-template later -->

        <div
          *ngIf="
            item.archived === false ||
            client ||
            fromOldSystem ||
            (offlineUpload && !item.archived)
          "
          class="d-flex box click-link max-picker-width"
        >
          <a
            download="{{ item.asset.name }}"
            [href]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
            style="margin-right: 7px"
            class="d-flex box"
          >
            <div class="filename">{{ shortenName(item?.asset?.name) }}</div>

            <a>
              <mat-icon aria-hidden="false" aria-label="remove">
                cloud_download
              </mat-icon>
            </a>
          </a>

          <a *ngIf="!disabled">
            <mat-icon
              style="cursor: pointer"
              aria-hidden="false"
              aria-label="remove"
              (click)="removeSizeFile(item, i)"
            >
              delete
            </mat-icon>
          </a>
        </div>

        <div
          *ngIf="
            item.archived === false ||
            client ||
            fromOldSystem ||
            (offlineUpload && !item.archived)
          "
        >
          <a
            class="click-link"
            [href]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
            *ngIf="isImage(item.asset)"
            data-lightbox="product"
          >
            <img
              class="max-picker-width max-picker-height"
              *ngIf="isImage(item.asset)"
              [src]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
            />
          </a>
        </div>
      </div>
    </ng-container>

    <div *ngIf="uploading">
      <mat-spinner
        style="margin: 30px 0 0 15px"
        color="primary"
        diameter="28"
      ></mat-spinner>
    </div>
  </div>
</div>
